module.exports = __webpack_public_path__ + "img/country-restricted-banner.d7a0418.jpg";